import { NgClass } from "@angular/common";
import { Component, Input } from "@angular/core";
import { EventBroker } from "@ponder-core/events/eventBroker";
import { UserStatsCategory } from "./user-stats-category";
import { Subscription } from "rxjs";

@Component({
    selector: "user-stat-category-button",
    imports: [NgClass],
    templateUrl: "./user-stat-category-button.component.html"
})
export class UserStatCategoryButtonComponent {
    @Input({ required: true }) public label!: string;
    @Input({ required: true }) public category!: UserStatsCategory;
    @Input() public isSelected: boolean = false;
    @Input() public isLast: boolean = false;

    private categorySelectedSub!: Subscription;

    public constructor(private events: EventBroker) {
        this.categorySelectedSub = this.events.stats.categorySelected.subscribe({
            next: (category: UserStatsCategory) => {
                this.isSelected = (this.category == category);
            }
        });
    }

    public ngOnDestroy(): void {
        this.categorySelectedSub.unsubscribe();
    }

    public onClicked(): void {
        if (this.isSelected) {
            return;
        }
        
        this.events.stats.categorySelected.emit(this.category);
    }
}